export const getCurrentUserName = () => {
  try {
    const persisted = localStorage.getItem("persist:root");
    if (!persisted) return "Desconocido";

    const root = JSON.parse(persisted);
    if (!root || !root.dataUser) return "Desconocido";

    const dataUser = JSON.parse(root.dataUser);
    if (!dataUser || Array.isArray(dataUser)) return "Desconocido";

    const nombres = (dataUser.nombres || "").trim();
    const apellidos = (dataUser.apellidos || "").trim();
    const nombreCompleto = `${nombres} ${apellidos}`.trim();

    return nombreCompleto || dataUser.nombre || dataUser.usuario || "Desconocido";
  } catch (error) {
    return "Desconocido";
  }
};

export const getCurrentUserId = () => {
  try {
    const persisted = localStorage.getItem("persist:root");
    if (!persisted) return null;

    const root = JSON.parse(persisted);
    if (!root || !root.dataUser) return null;

    const dataUser = JSON.parse(root.dataUser);
    if (!dataUser || Array.isArray(dataUser)) return null;

    const id = parseInt(dataUser.id, 10);
    return Number.isNaN(id) ? null : id;
  } catch (error) {
    return null;
  }
};